import { isValidElement as P, Children as F } from "react";
const l = () => !!(typeof window < "u" && window.document && window.document.createElement);
function _(e) {
  return 1 - Math.pow(1 - e, 4);
}
function G({
  targetPosition: e,
  initialPosition: t,
  duration: n
}) {
  if (!l())
    return;
  let r, c, o = 0;
  const s = window.requestAnimationFrame, O = window.cancelAnimationFrame, m = document.documentElement.scrollHeight - document.documentElement.clientHeight, x = t - e;
  function d(p) {
    r === void 0 && (r = p);
    const f = p - r, R = f / n, T = _(R);
    if (c = t - x * Math.min(T, 1), window.scrollTo(0, c), t !== m && window.scrollY === m) {
      O(o);
      return;
    }
    f < n && (o = s(d));
  }
  o = s(d);
}
const Y = (e) => (t) => {
  e.forEach((n) => {
    typeof n == "function" ? n(t) : n && (n.current = t);
  });
}, C = {
  xs: 0,
  sm: 360,
  md: 768,
  lg: 1024,
  xl: 1366,
  xxl: 1920
}, j = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1366,
  xxl: 1720
}, q = {
  ESC: "Escape",
  TAB: "Tab",
  SPACE: "Space",
  ARROW_UP: "ArrowUp",
  ARROW_RIGHT: "ArrowRight",
  ARROW_DOWN: "ArrowDown",
  ARROW_LEFT: "ArrowLeft",
  ENTER: "Enter"
}, z = {
  ESC: "Escape",
  TAB: "Tab",
  SPACE: " ",
  ARROW_UP: "ArrowUp",
  ARROW_RIGHT: "ArrowRight",
  ARROW_DOWN: "ArrowDown",
  ARROW_LEFT: "ArrowLeft",
  ENTER: "Enter"
}, Q = ({ baseTestId: e, dataTestHook: t }) => (n = "") => {
  const r = (t == null ? void 0 : t.includes("@hpstellar")) || !1, c = r && (t == null ? void 0 : t.split("--")) || [];
  let o = r ? c[0] || "" : e;
  (n || n === 0) && (o += `__${n}`);
  const s = r ? c[1] || "" : t;
  return s && (o += `--${s}`), o;
}, Z = (e, t) => {
  let n;
  return (...r) => {
    n && clearTimeout(n), n = window.setTimeout(() => e(...r), t);
  };
}, i = typeof window < "u" ? window : { screen: {}, navigator: {} };
var g;
const a = ((g = i.matchMedia) == null ? void 0 : g.bind(i)) || (() => ({ matches: !1 }));
let A = !1;
const I = {
  get passive() {
    return A = !0;
  }
}, S = () => {
};
i.addEventListener && i.addEventListener("p", S, I);
i.removeEventListener && i.removeEventListener("p", S, !1);
const J = A, X = "PointerEvent" in i, u = "ontouchstart" in i, $ = "TouchEvent" in i, b = u || $ && a("(any-pointer: coarse)").matches, h = (i.navigator.maxTouchPoints || 0) > 0 || b, y = i.navigator.userAgent || "", L = a("(pointer: coarse)").matches && // both iPad and iPhone can "request desktop site", which sets the userAgent to Macintosh
// so need to check both userAgents to determine if it is an iOS device
// and screen size to separate iPad from iPhone
/iPad|Macintosh/.test(y) && Math.min(i.screen.width || 0, i.screen.height || 0) >= C.md, v = (a("(pointer: coarse)").matches || // if the pointer is not coarse and not fine then the browser doesn't support
// interaction media queries (see https://caniuse.com/css-media-interaction)
// so if it has onTouchStartInWindow assume it has a coarse primary pointer
!a("(pointer: fine)").matches && u) && // bug in firefox (as of v81) on hybrid windows devices where the interaction media queries
// always indicate a touch only device (only has a coarse pointer that can't hover)
// so assume that the primary pointer is not coarse for firefox windows
!/Windows.*Firefox/.test(y), W = a("(any-pointer: fine)").matches || a("(any-hover: hover)").matches || // iPads might have an input device that can hover, so assume it has anyHover
L || // if no onTouchStartInWindow then the browser is indicating that it is not a touch only device
// see above note for supportsTouchEvents
!u, E = h && (W || !v) ? "hybrid" : h ? "touchOnly" : "mouseOnly", H = E === "mouseOnly" ? "mouse" : E === "touchOnly" || // if the device is a hybrid, then if the primary pointer is coarse
// assume the primaryInput is touch, otherwise assume it's mouse
v ? "touch" : "mouse", k = () => {
  var e;
  return (e = i.navigator.userAgent) == null ? void 0 : e.match(/iPhone|Android/i);
}, V = (e) => `data-${e.replace(
  /[A-Z]/g,
  (t) => `-${t.toLocaleLowerCase()}`
)}`, M = (e) => e ? Object.keys(e).reduce((t, n) => {
  const r = e[n];
  return r == null ? t : { ...t, [V(n)]: r };
}, {}) : {}, ee = (e, t) => {
  const n = (e == null ? void 0 : e.get(t)) || {};
  return M(n);
}, N = (e) => `${Math.max(20, Math.min(e.width / 20, 40))}px sans-serif`, te = ({
  width: e,
  height: t,
  bgColor: n = "#cecece",
  color: r = "#969696",
  text: c
}) => {
  if (!l())
    return;
  const o = document.createElement("canvas"), s = o.getContext("2d");
  if (s)
    return o.width = e, o.height = t, s.fillStyle = n, s.fillRect(0, 0, o.width, o.height), s.font = N(o), s.fillStyle = r, s.textAlign = "center", s.textBaseline = "middle", s.fillText(
      c || `${e} x ${t}`,
      o.width / 2,
      o.height / 2
    ), o.toDataURL();
}, ne = (e) => {
  if (l())
    return getComputedStyle(document.documentElement).getPropertyValue(
      e
    );
}, D = (e) => {
  if (e && e.length)
    return e.map(({ url: t, width: n }) => `${t} ${n}w`).join(", ");
}, re = (e, t) => Array.isArray(t) ? { srcSet: D(t) } : { srcSet: e, sizes: t }, oe = (e) => e === void 0 ? !1 : typeof e == "string" ? e.length !== 0 : Object.keys(e).length !== 0, w = (e) => e != null && e.constructor.name === "Object", B = (...e) => e.reduce((t, n) => (Object.keys(n).forEach((r) => {
  const c = t[r], o = n[r];
  w(c) && w(o) ? t[r] = B(c, o) : t[r] = o;
}), t), {}), se = (e, t) => Object.keys(t).reduce((n, r) => (e.includes(r) || (n[r] = t[r]), n), {}), ce = (e, t = []) => t.reduce((n, r) => (r in e && (n[r] = e[r]), n), {}), ie = (e) => {
  let t = "", n;
  typeof e == "number" ? n = parseFloat(e.toFixed(1)).toString() : typeof e == "string" ? (e.includes(",") ? t = e.replace(",", ".") : t = e, n = parseFloat(parseFloat(t).toFixed(1)).toString()) : n = "0";
  const r = n.split(".")[0], c = n.includes(".") ? `0.${n.split(".")[1]}` : "0";
  return {
    roundedScore: n,
    integer: r,
    decimal: c
  };
}, ae = (e) => {
  const t = typeof document < "u" ? parseFloat(getComputedStyle(document.documentElement).fontSize) : 16;
  return e * t;
}, le = (e, t, n = "...") => e.length > t ? `${e.substring(0, t)}${n}` : e, ue = (e, t) => {
  e && process.env.NODE_ENV !== "production" && console.error(t);
  try {
    throw new Error(t);
  } catch {
  }
}, me = (e, t, n, r, c = "initial") => {
  const o = document.createElement("div");
  o.style.cssText = `
    position: 'fixed';
    top: '-100%';
    width: ${t};
    font-family: ${c};
    font-size: ${r};
    line-height: ${n};
  `, o.innerHTML = e, document.body.appendChild(o);
  const s = Math.round(
    o.offsetHeight / parseInt(n, 10)
  );
  return document.body.removeChild(o), s;
}, K = (e) => typeof e == "string" ? e : typeof e == "number" ? e.toString() : P(e) ? F.toArray(e.props.children).map((t) => K(t)).join("") : "";
export {
  C as BREAKPOINTS,
  j as BREAKPOINTS_VIS_ID,
  q as KEY_EVENT_CODES,
  z as KEY_EVENT_KEYS,
  G as animateScroll,
  me as calculateLinesCount,
  Y as composeRefs,
  Q as createDataTestHook,
  Z as debounce,
  E as deviceType,
  K as extractInnerText,
  ee as formatGtmAction,
  M as formatGtmAttrs,
  te as generatePlaceholderImage,
  ne as getCSSVariableValue,
  re as getImgSrcSetAndSizes,
  D as getSrcSet,
  l as isBrowser,
  k as isIOSOrAndroid,
  oe as isNotEmpty,
  B as merge,
  se as omit,
  ce as pick,
  H as primaryInput,
  ie as processValue,
  ae as remToPx,
  J as supportsPassiveEvents,
  X as supportsPointerEvents,
  b as supportsTouchEvents,
  le as truncateText,
  ue as warning
};
